import { GeneralAPRCalculator } from "../Apps/GeneralAPRCalculator"

function AppGeneralAPRCalculator() {

  return (
    <GeneralAPRCalculator />
  )
}

export default AppGeneralAPRCalculator

